type Fn<T, U> = (x: T) => U;

export const ifDefined =
  <T, U>(fn: Fn<T, U>) =>
  (x: T | undefined): U | undefined =>
    x === undefined ? undefined : fn(x);
